module.exports = require("@epam/uui-components");